export default __webpack_public_path__ + "static/media/234.edc0938a.jpg";